import React, { useState, useEffect } from "react";
import connect from "react-redux/es/connect/connect";
import ChatBotModal from "./ChatBotModal";
import { PERMISSIONS } from "../../constants";
import { isAssistantPathEnabled } from "../../pages/functions";
import ChatBot from "./ChatBot";
import BotImage from "./assets/ami_en.png";
import boing from "./assets/boing.png";
import { api } from "../index.api";
import { callAnalyticsLink, wrapAnalyticsLinks } from "../../helpers/analytics";
import { ANALYTICS_LINK_TYPES, ANALYTICS_LINK_SECTIONS } from "../../constants";
import "./style.css";

const ChatConfig = (props) => {
  const [tree, setTree] = useState([]);
  const [currentNode, setCurrentNode] = useState({});
  const [navStack, setNavStack] = useState([]);
  const [minimized, setMinimized] = useState(true);
  const [showAssistant, setShowAssistant] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const tempImage = BotImage;

  useEffect(() => {
    if (
      props.permissions &&
      props.permissions.indexOf(PERMISSIONS.ASSISTANT) !== -1
    ) {
      const assistantEnabled = isAssistantPathEnabled();
      if (assistantEnabled) {
        setShowAssistant(true);
      }
    }
  }, [props.permissions, props.referenceData]);

  useEffect(() => {
    wrapAnalyticsLinks(".assistant-container", "assistant");
  });

  useEffect(() => {
    if (
      props.referenceData &&
      props.referenceData.SelectedCountry &&
      props.referenceData.UserType &&
      props.referenceData.SelectedLanguage
    ) {
      const payload = {
        country: props.referenceData.SelectedCountry.name || "",
        userType: props.referenceData.UserType || "",
        language: props.referenceData.SelectedLanguage || "",
      };
      // api.getAMIData is async and expects a success callback. It does not return the data synchronously.
      api.getAMIData(payload, (response) => {
        try {
          // response is already parsed by the API helper (it calls resp.json()).
          const jsonObj =
            typeof response === "string" ? JSON.parse(response) : response;
          setTree((jsonObj && jsonObj.hierarchical) || []);
        } catch (err) {
          console.error("Failed to parse AMI data", err, response);
          setTree([]);
        }
      });
    } else {
      setTree([]);
    }
  }, [props.referenceData]);

  useEffect(() => {
    if (tree.length > 0) {
      setCurrentNode(tree[0]);
      setNavStack([]);
      setMessages([
        {
          type: "bot",
          content: tree[0].htmlContent,
          time: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
        },
      ]);
    } else {
      // Set to empty object instead of null
      setCurrentNode({});
      setNavStack([]);
      setMessages([]);
    }
  }, [tree]);

  const handleBoing = () => {
    setMinimized(!minimized);
  };

  const handleOpen = () => {
    setModalOpen(true);
    setMinimized(false);
    callAnalyticsLink(
      ANALYTICS_LINK_TYPES.CUSTOM_LINK,
      ANALYTICS_LINK_SECTIONS.ASSISTANT + "Open Ami",
      "assistant"
    );
  };

  // Go Back and Reset handlers to pass down
  const goBack = () => {
    if (navStack.length === 0) return;
    setLoading(true);
    setTimeout(() => {
      setCurrentNode(navStack[navStack.length - 1]);
      setNavStack(navStack.slice(0, navStack.length - 1));
      setMessages((msgs) =>
        msgs.concat(
          {
            type: "user",
            content: "← Going back to previous level",
            time: new Date().toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            }),
          },
          {
            type: "bot",
            content: navStack[navStack.length - 1].htmlContent,
            time: new Date().toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
            }),
          }
        )
      );
      setLoading(false);
    }, 300);
  };

  const resetChat = () => {
    setCurrentNode(tree[0]);
    setNavStack([]);
    setMessages([
      {
        type: "user",
        content: "Resetting chat to start over",
        time: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      },
      {
        type: "bot",
        content: tree[0].htmlContent,
        time: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      },
    ]);
  };

  return (
    <div>
      {showAssistant && Object.keys(currentNode).length > 0 && (
        <div className="assistant-container">
          <div className="assistant-toggle">
            <span
              id="hidAmi"
              className={`fa fa-close fa-lg toggle-minimize ${
                minimized ? "hidden" : ""
              }`}
              style={{ zIndex: 1051 }}
              onClick={handleBoing}
            />
            <img
              id="assistantButton"
              className={`toggle-image ${minimized ? "hidden" : ""}`}
              style={{ zIndex: 1051 }}
              src={tempImage}
              alt="Ami"
              onClick={handleOpen}
            />
            <img
              className={`boing ${!minimized ? "hidden" : ""}`}
              style={{ zIndex: 1051 }}
              src={boing}
              alt="Boing"
              onClick={handleBoing}
            />
          </div>
          <ChatBotModal
            isOpen={modalOpen}
            onClose={() => setModalOpen(false)}
            goBack={goBack}
            resetChat={resetChat}
            navStack={navStack}
          >
            {Object.keys(currentNode).length > 0 && (
              <ChatBot
                navStack={navStack}
                setNavStack={setNavStack}
                setCurrentNode={setCurrentNode}
                currentNode={currentNode}
                messages={messages}
                setMessages={setMessages}
                loading={loading}
                setLoading={setLoading}
                tree={tree}
              />
            )}
          </ChatBotModal>
        </div>
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const refDataObj = state.referenceData.find(
    (item) => item.type === "REF_DATA"
  );
  return {
    referenceData: refDataObj ? refDataObj.referenceData : {},
    permissions: state.permissions,
  };
}

export default connect(mapStateToProps)(ChatConfig);



// WEBPACK FOOTER //
// ./src/mi-app/AMI_assistant/ChatConfig.js